import { Backdrop, Box, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { getAnalysisType, getUserCountries } from "./analyzeSlice";
import Data from "./data/Data";
import NewCustomer from "./newcustomer/NewCustomer";
import Customer from "./customer/Customer";
// import Scenario from "./scenario/Scenario";
import QuotaDetails from "./quotaDetails/QuotaDetails";
import Modifications from "./modifications/Modifications";
import FourPL from "./FourPL/FourPL";
// import TradeDetails from "./tradeDetails/TradeDetails";
// import IntendedVSDelivered from "./intendedVSDelivered/IntendedVSDelivered";
import GenerateReports from "./GenerateReport/GenerateReports";
// import SupplyDemand from "./supplydemand/SupplyDemand";
// import PowerBiReport_TEST from "../powerbi/PowerBiReport_TEST";
import SiMSPowerBiEmbedComponent from "../powerbi/SiMSPowerBiEmbedComponent"; 
import SiMSPowerBiEmbedComponent_QuotaModifications from "../powerbi/SiMSQuotaModificationsComponent";
import SiMSPowerBiEmbedComponent_QuotaModificationsAdminHQ from "../powerbi/SiMSQuotaModificationsComponentAdminHQ";
import CustomLoadingScreen from "../../components/ui/CustomLoadingScreen";

export default function AnalyseData() {
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const global = useSelector((store) => store.global);
  const login = useSelector((store) => store.login);  

  //KB added to get user role from local storage
  const [userRole, setUserRole] = React.useState("");
  const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);

  useEffect(() => {
    if (data && data.roleName) {
      setUserRole(data.roleName);
    }
  }, [data]);
  


  const { drawerOpen } = global;
  const { isLoading, analysisTypes, selectedAnalysisType, countries } = state;    
  
//  alert(JSON.stringify(userRole));  

  useEffect(() => {
    if (analysisTypes.length <= 0) {
      dispatch(getAnalysisType());
    }
    //if (countries.length <= 0) {
      dispatch(getUserCountries());
    //}
  }, []);  
  

  if (!countries || countries.length < 1) {
    return <CustomLoadingScreen isLoading={isLoading}/>;
  }

  return (
    <Box sx={{ p: 1, maxWidth: drawerOpen ? "1160px" : "95vw" }}>
      {/* LOADING SCREEN */}
      <Box>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={isLoading}
        >
          <CircularProgress />
        </Backdrop>
      </Box>
      {/* <ComponentTests /> */}
      <Header />
      {selectedAnalysisType === "Data" && <Data />}
      {selectedAnalysisType === "New Customer" && <NewCustomer />}
      {selectedAnalysisType === "Customer" && <Customer />}
      {/* {selectedAnalysisType === "Scenario" && <Scenario />} */}
      {selectedAnalysisType === "Quota Details" && <QuotaDetails />}
      {selectedAnalysisType === "Modifications" && <Modifications />}
      {/* {selectedAnalysisType === "Trade Details" && <TradeDetails />}
      {selectedAnalysisType === "Intended vs Delivered" && (
        <IntendedVSDelivered />
      )} */}
      {selectedAnalysisType === "3PL export partner" && <FourPL />}
      {selectedAnalysisType === "Backend Reports" && <GenerateReports />}
      {selectedAnalysisType === "Generate Reports" && <GenerateReports />}
      {selectedAnalysisType === "Supply & Demand Dynamics" && <SiMSPowerBiEmbedComponent />}
      {/* /*check if user is admin or HQ approver to show the quota modifications report */}
      {selectedAnalysisType === "Quota Modifications" && userRole =="Administrator" &&  <SiMSPowerBiEmbedComponent_QuotaModificationsAdminHQ />} 
      {selectedAnalysisType === "Quota Modifications" && userRole =="HQApprover" &&  <SiMSPowerBiEmbedComponent_QuotaModificationsAdminHQ />} 

      {selectedAnalysisType === "Quota Modifications" && userRole =="CountryAnalyst" &&  <SiMSPowerBiEmbedComponent_QuotaModifications />} 
      {selectedAnalysisType === "Quota Modifications" && userRole =="HQAnalyst" &&  <SiMSPowerBiEmbedComponent_QuotaModifications />} 
      {selectedAnalysisType === "Quota Modifications" && userRole =="CountryApprover" &&  <SiMSPowerBiEmbedComponent_QuotaModifications />} 

    </Box>
  );
}
